import BaseEntity from '../base/BaseEntity.model';

export default class Persona extends BaseEntity{
    public cedula?: string;
    public nombre1?: string;
    public nombre2?: string;
    public apellido1?: string;
    public apellido2?: string;
    public sexo?: 'M'|'F';
    public estadoCivil?: string;
    public foto?: string;
    public fechaNacimiento?: Date | string;
    public noActNacimiento?: string;
    public folio?: string;
    public libro?: string;
    public ultimoNivelAcademico?: string;
    public estaEstudiando?: boolean;
    public centroAcademicoId?: number;
    public centroAcademicoOtro?: string;
    public cursoEstudiante?: string;
    public discapacitado?: boolean;
    public incapacitado?: boolean;
    public lee?: boolean;
    public escribe?: boolean;
    public embarazada?: boolean;
    public tiempoEmbarazo?: number;
    public medidaTiempoEmbarazo?: MedidaTiempoEmbarazo;
    public nombreCompleto?: string;
    public nombreSemiCompleto?: string;
    public edad?: number;
    public edadText?: string;
    public cedulaPadre?: string;
    public cedulaMadre?: string;
    public telefono?: string;
    public codigoHogarSiuben?: string;
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = undefined;
        this.cedula = undefined;
        this.centroAcademicoOtro = undefined;
        this.cedulaMadre = undefined;
        this.cedulaMadre = undefined;
        this.nombre1 = undefined;
        this.nombre2 = undefined;
        this.apellido1 = undefined;
        this.apellido2 = undefined;
        this.sexo = undefined;
        this.estadoCivil = undefined;
        this.foto = undefined;
        this.fechaNacimiento = undefined;
        this.noActNacimiento = undefined;
        this.centroAcademicoId = undefined;
        this.cursoEstudiante = undefined;
        this.discapacitado = undefined;
        this.incapacitado = undefined;
        this.lee = undefined;
        this.escribe = undefined;
        this.embarazada = undefined;
        this.tiempoEmbarazo = undefined;
        this.medidaTiempoEmbarazo = 0;
        this.nombreCompleto = undefined;
        this.edad = undefined;
        this.edadText = undefined;
        this.telefono = undefined;
    }
}

export enum MedidaTiempoEmbarazo{
    Dias = 0,
    Semanas = 1,
    Meses = 2
}